export type IMgmSharedResources = typeof MgmSharedResources;

export const MgmSharedResources = {
    mgmHowItWorks: {
        title: "Jak to <b>działa</b>?",
        item1Text:
            "<b>Wysyłasz link lub kod polecający znajomemu, który wcześniej nie robił zakupów przez goodie cashback.</b> Możesz wykorzystać gotowy lub stworzyć własny.",
        item2Text:
            "Znajomy <b>rejestruje się w goodie za pomocą Twojego linka</b> lub podaje kod podczas rejestracji.",
        item3Text:
            "Teraz wystarczy tylko, że w ciągu 30 dni <b>zrobi zakupy z goodie cashback za min. 80 zł.</b>",
        item4Text: "Gotowe! Ty i Twój znajomy <b>otrzymujecie bonus!</b>",
    },

    mgmTransactionSummary: {
        modalTitle: "Twoje bonusy za polecanie",
        tabPending: "Oczekujące",
        tabApproved: "Zatwierdzone",
        tabRejected: "Odrzucone",
        noTransactionTitle: "Brak bonusów odrzuconych",
        noTransactionDescription:
            "Jeżeli Twój znajomy nie zrobi zakupów w ciągu 30 dni od momentu rejestracji, tutaj zobaczysz listę bonusów, które nie zostały przyznane.",
        usersRegisteredToMeLabel: "Użytkownicy zarejestrowani z Twojego polecenia",
        completedBonusLabel: "Zrealizowanie bonusu: ",
        beforeCompletedBonusLabel: "Przed realizacją bonusu: ",
        totalBonusReceivedLabel: "Dotychczasowa wypłata: {totalAmount}",
        tableHeaderDateLabel: "Data rejestracji",
        tableHeaderAmountLabel: "Wysokość bonusu",
        tableHeaderStatusLabel: "Status",
    },

    noPendingBonus: {
        label: "Brak bonusów oczekujących",
        text: "Tutaj zobaczysz oczekujące bonusy za polecenie, gdy polecone przez Ciebie osoby zarejestrują się w goodie.",
    },
    noApprovedBonus: {
        label: "Brak bonusów zatwierdzonych",
        text: "Gdy Twój znajomy zrobi pierwsze zakupy z goodie cashback, zobaczysz tutaj przyznane bonusy gotowe do wypłaty.",
    },
    noRejectedBonus: {
        label: "Brak bonusów odrzuconych",
        text: "Jeżeli Twój znajomy nie zrobi zakupów w ciągu 30 dni od momentu rejestracji, tutaj zobaczysz listę bonusów, które nie zostały przyznane.",
    },

    mgmNumbersSummary: {
        title: "<b>Twoje podsumowanie</b>",
        step1: "Twoje oczekujące bonusy",
        step2: "Twoje naliczone bonusy",
        step3: "Użytkownicy zarejestrowani z Twojego polecenia",

        openSummaryBtnLabel: "Szczegóły",
    },
};
